import { useMemo } from 'react';
import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums/location_feature_enum.pb';
import { useScopedAppFlagStore } from '@frontend/scope';

export const useHasCallIntelFeature = () => {
  const { getCustomizationFlagLocationMap } = useScopedAppFlagStore();

  return useMemo(() => {
    const locationMap = getCustomizationFlagLocationMap('callintelligence');
    return Object.values(locationMap ?? {}).some(
      (data) => !!data?.state && (data.isFreeTrial || [State.ACTIVE, State.PROMOTE].includes(data.state))
    );
  }, [getCustomizationFlagLocationMap]);
};
